import { services as programacaoAbate } from '@/modules/programacaoAbate'

export default {
    programacaoAbate
}